module.exports = __webpack_public_path__ + "media/promo/courses/images/format-bg-acb192a808d728d71203ecd3a20c3395.png";